export function addCurrent(organizationcategoryportal) {
    return {
        type: 'ADD_CURRENT',
        organizationcategoryportal,
    }
}

